import { memoize, capitalize } from 'lodash';

export default () => {
  return memoize(capitalize);
};
